import './style.scss'


jQuery(()=>{
  let gridtab_navigations = jQuery('.gridtab_navigation');
  let gridtab_targets = jQuery('.gridtab_target');

  jQuery.each(gridtab_navigations, function(index,gridtab_navigation){
    gridtab_navigation = jQuery(gridtab_navigation)
    if(gridtab_navigation.hasClass('disabled')){
      return;
    }
    
    let gridtab_target = gridtab_targets.eq(index)

    let navElements = gridtab_navigation.find('.flex_cell')
    let targetElements = gridtab_target.find('.flex_cell')

    targetElements.append('<a class="close">X</a>');
    targetElements.find('.close').click(()=>{
      navElements.removeClass('active');
      targetElements.removeClass('active');
    });

    jQuery.each(navElements, function(index,elem){
      elem = jQuery(elem)
      elem.click(function(event){
        event.preventDefault()
        if(elem.hasClass('active')){
          navElements.removeClass('active')
          targetElements.removeClass('active')
        }else{
          navElements.removeClass('active')
          targetElements.removeClass('active')
          elem.addClass('active');
          targetElements.eq(index).addClass('active');
        }
      })
    })
  })
})

console.log("init gridtabs");



// WEBPACK FOOTER //
// ./components/gridtabs/index.js